import React, { Component } from 'react';
import './ProjectsPanel.css';
import ProjectBlock from './ProjectBlock';
export const id = 'projectsPanel';

const projectsContext = require.context('!raw-loader!./res/projects', false, /.*\.md/);
var projects = [];
projectsContext.keys().forEach(function (key) {
  projects.push(projectsContext(key));
});

class ProjectsPanel extends Component {
  render() {
    const projectsContainerClass = this.props.isMobile ?
      'MobileProjectsContainer' :
      'ProjectsContainer';
    
    const projectCount = Object.keys(projects).length;
    let currentProject = 0;
    const renderedProjectBlocks = projects.map(markdown => {
      currentProject++;
      return (
        <ProjectBlock
          key={`projectBlock-${currentProject}`}
          id={`projectBlock-${currentProject}`}
          backgroundColor={currentProject % 2 === 0 ? '#EEEEEE' : '#FFFFFF'}
          markdown={markdown}
          showDivider={currentProject < projectCount}/>
      )
    });
    return (
      <div className="ProjectsPanel" id={id}>
        <div className="ProjectsPanelBlurb">
          <div id="ProjectsContainer" className={projectsContainerClass}>
            <h2>My favorite projects, and why?</h2>
            <em>An incomplete list of projects that I've worked on: just the highlights</em>
            <p/>
            {renderedProjectBlocks}
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectsPanel;



// WEBPACK FOOTER //
// ./src/ProjectsPanel.js